import { render, staticRenderFns } from "./show_component.vue?vue&type=template&id=7a49bc28"
import script from "./show_component.js?vue&type=script&lang=js&external"
export * from "./show_component.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports